/**
 * Licensed Materials - Property of IBM
 *
 * "Restricted Materials of IBM"
 *
 * (C) Copyright IBM Corp. 2018
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * An action controller to handle links that display under the Help menu; contributed by Explore, in particular: the tutorials link.
 */

const BaseClass = require('gemini/lib/@waca/core-client/js/core-client/ui/core/Class');

var ActionHandler = BaseClass.extend({

	actionHandlers: {
		'tutorials': function() { return this._openExternalPage('https://www.youtube.com/playlist?list=PLfq0ST5X3p-R0Q6PqFXBO4Al0JNxsr1J2'); }
	},

	/**
	 * Menu item handler
	 */
	onSelectItem: function(context) {
		const key = this._getPluginKey(context.target.itemId);
		const action = this.actionHandlers[key];
		if (action) {
			return action.call(this);
		}
	},

	_openExternalPage: function(url) {
		window.open(url, '_blank');
	},

	_getPluginKey: function(itemId) {
		const idTokens = itemId.split('.');

		return idTokens[idTokens.length - 1];
	}

});

export default ActionHandler;



// WEBPACK FOOTER //
// ./src/js/glass/controllers/LinksActionController.js